import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { SButton, SButtonProps } from "components/parts";
import { STheme } from "components/styles";
/**
 * 追加情報ボタン
 */

/**
 * プロパティ
 */
type Props = Pick<
  SButtonProps,
  | "focusId"
  | "label"
  | "index"
  | "gridColumn"
  | "gridRow"
  | "align"
  | "disabled"
  | "onBlur"
  | "onChange"
  | "onKeyDown"
  | "onClick"
  | "onDoubleClick"
  | "dialog"
  | "dialogAction"
  | "handleSubmit"
>;

/**
 * 追加情報ボタン
 *
 * @param label: ボタンのラベル
 * @param index: フォーカス番号(1～)
 * @param gridColumn: CSSグリッドの列位置を指定する
 * @param gridRow: CSSグリッドの行位置を指定する
 * @param disabled: 非活性
 * @returns JSX.Element
 */
export const SInfoButton = (props: Props): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <SButton {...props} />
    </ThemeProvider>
  );
};

const theme = createTheme(
  {
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            backgroundColor: STheme.buttons.info,
            color: STheme.buttons.text,
            ":hover": {
              backgroundColor: STheme.buttons.hover.info,
              color: STheme.buttons.hover.text,
            },
            padding: "1px 4px",
          },
        },
      },
    },
  },
  { ...STheme }
);
